import { render, staticRenderFns } from "./FeaturedAlbum.vue?vue&type=template&id=3b7318af&scoped=true&"
import script from "./FeaturedAlbum.vue?vue&type=script&lang=js&"
export * from "./FeaturedAlbum.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedAlbum.vue?vue&type=style&index=0&id=3b7318af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7318af",
  null
  
)

export default component.exports